import MainButton from "components/MainButton";
import MainCard from "components/MainCard";
import Layout from "Layout";
import React from "react";
import SecondaryButton from "components/SecondaryButton";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useCallback } from "react";
import { getCapaianByKategori, getKategoriCapaian, getPencapaian, searchCapaian } from "services/apiRoutes";
import { useEffect } from "react";
import SkeletonMaincard from "skeletons/SkeletonMaincard"

export default function Pencapaian() {
  const { slug } = useParams();

  const [capaian,setCapaian]= useState();
  const [kategori,setKategori]=useState();
  const [counter,setCounter]=useState(3);
  const [total, setTotal] = useState();
  const [loading,setLoading]=useState(false);
  const [active,setActive]=useState();
  const [defaultKategori,setDefaultKategori]=useState(true);
  const [keyword,setKeyword]=useState();

  const capaianAPI = useCallback(async (limit,offset)=>{
    setLoading(true);
    const res = await getPencapaian(limit,offset,slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setCapaian(data);
      const { jumlahData } = res.data;
      setTotal(jumlahData);
      setLoading(false);
      setDefaultKategori(true);
      setActive(null);
    }
  },[slug])


    const kategoriCapaianAPI = useCallback(async () => {
      const res = await getKategoriCapaian(slug);
      if (res.error) {
        return res.message;
      } else {
        const { data } = res.data;
        setKategori(data);
      }
    }, [slug]);


        const capByKategoriAPI = useCallback(async (uuid, indexBtn) => {
          setLoading(true);
          const res = await getCapaianByKategori(20, 0, uuid,slug);
          if (res.error) {
            return res.message;
          } else {
            setLoading(false);
            const { data } = res.data;
            setCapaian(data);
            setActive(indexBtn);
            setDefaultKategori(false);
          }
        }, [slug]);

        const handleCounter = () => {
          setCounter(counter + 3);
        };

        const searchKegAPI = useCallback(async (limit, offset, keyword) => {
          setLoading(true);
          const res = await searchCapaian(limit, offset, keyword,slug);
          if (res.error) {
            return res.message;
          } else {
            setLoading(false);
            const { data } = res.data;
            setCapaian(data);
          }
        }, [slug]);

        const seacrhCap = () => {
          searchKegAPI(100, 0, keyword);
        };

        const handleKeypress = (e) => {
          if (e.key === "Enter") {
            searchKegAPI(100, 0, keyword);
          }
        };


  useEffect(() => {
    capaianAPI(counter, 0);
    kategoriCapaianAPI();
  }, [capaianAPI, kategoriCapaianAPI,keyword,counter]);


  const navigate = useNavigate();
  return (
    <>
      <Layout>
        <div className="px-5 xl:pt-56 pt-28 kegiatan-wrapper xl:px-99">
          <h1 className="text-2xl font-bold xl:text-7xl">Gallery Gampong</h1>
          <div className="mt-[78px] font-bold text-sm">Cari:</div>
          <input
            type="text"
            onChange={(e) => setKeyword(e.target.value)}
            onKeyPress={handleKeypress}
            placeholder="Cari Gallery"
            className="px-5 py-3 my-4 border seacrh rounded-2xl focus:outline-none xl:w-[994px] mr-4 w-full focus:ring-2 focus:ring-primary focus:border-none"
          />
          <MainButton label="Cari" onClick={() => seacrhCap()} />
          {capaian?.length !== 0 ? null : (
            <h1 className="font-bold">{`"${keyword}" Tidak Ditemukan`}</h1>
          )}
          <div className="flex mt-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden">
            <div className="text-sm font-bold">Filter</div>
            {kategori
              ? kategori?.map((item, index) => (
                  <MainButton
                    secondType
                    label={item?.nama}
                    key={index}
                    activeBtn={active === index ? true : false}
                    onClick={() => capByKategoriAPI(item.uuid, index)}
                  />
                ))
              : null}

            <MainButton
              secondType
              label="Semua"
              activeBtn={defaultKategori}
              onClick={() => capaianAPI(100, 0)}
            />
          </div>
          <div className="gap-5 space-y-5 md:grid md:grid-cols-2 xl:grid-cols-3 mt-14 content xl:space-y-0">
            {!loading
              ? capaian?.map((item, index) => (
                  <MainCard
                    key={index}
                    title={item?.nama}
                    label={
                      item?.list_kategori_capaian_obj[0]
                        ? item?.list_kategori_capaian_obj[0].kategori_obj.nama
                        : ""
                    }
                    img={item?.url_gambar}
                    onClick={() =>
                      navigate(`/${slug}/postpencapaian/${item?.uuid}`)
                    }
                  />
                ))
              : [1, 2, 3, 4, 5, 6].map((x) => <SkeletonMaincard />)}
          </div>
          <div className="flex items-center justify-center py-32 loadMore">
            {counter >= total ? (
              <h1 className="font-bold">Sudah mentok!</h1>
            ) : (
              <SecondaryButton
                label="Lebih Banyak"
                onClick={() => handleCounter()}
                loading={loading}
              />
            )}
          </div>
        </div>
      </Layout>
    </>
  );
}
